<template>
  <div
    class="right-presentation"
    @mouseup.stop
    :class="{
      'mobile-active': $store.state.activeModelDetailSlide,
      'show-grid': showingSlideGrid
    }"
  >
    <TakeOverToolbar class="take-over--side-right" />
    <SyncLoadingAndMobileTurnOffTabContent v-if="$store.state.activeModelDetailSlide" />
    <div
      class="content-right-presentation"
      v-if="slideActive.activeTab !== null"
    >
      <ActiveTab
        @activeTabSlide="activeTabSlide"
        :selectedSlideIds="selectedSlideIds"
        :showingAudioTab="showingAudioTab"
      />

      <div class="overlay-disable-edit" v-if="isDisableEditPresentation"></div>
      <div
        class="tab-content-presentation"
        v-if="slideActive.activeTab == 1"
      >
        <div
          v-for="typeObj in allTypeSections"
          :key="typeObj.type"
          style="overflow: hidden"
          class="pb-3"
        >
          <div class="title-table-presentation">
            <span class="text-secondary-100">{{ typeObj.title }} </span>
            <span class="title-table-presentation-tooltip">
              <b-button v-tooltip="typeObj.desc" class="tooltip-btn" />
              <i class="fas fa-question-circle"></i>
            </span>
          </div>
          <div class="slide-types-wrapper">
            <div
              class="box-type"
              v-for="item in typeObj.slideTypes"
              :key="item.type + item.slideType"
              :class="{
                beta: item.beta,
                new: item.isNew,
                legacy: item.isLegacy,
                updated: item.isUpdated,
                popular: item.isPopular,
                comingsoon: item.isComingSoon,
                active: isBoxTypeActive(item),
                'is-eu': item.type === 'openEnded' && isEURegion,
                'd-none': item.hidden,
              }"
              v-show="!item.noType"
              @mouseenter="handleHoverOnSlideType(item, 'over')"
              @mouseleave="handleHoverOnSlideType(item, 'out')"
              v-tooltip="item.isLegacy ? boxLegacyTooltip : ''"
            >
              <div
                class="box-content vertical layout center-justified ml-0.25 relative"
                @click="item.isLegacy
                  ? false
                  : handleSelectSlideType({ item, property: 'side-right' })
                "
                :class="[item.isLegacy ? 'default': 'pointer']"
              >
                <FeatureUpdateTooltipContent
                  :title="featureTooltipTitle(item.type)"
                  :content="featureTooltipContent(item.type)"
                  v-if="isFeatureUpdateTooltipVisible(item)"
                />
                <SlideTypeIcon
                  :slide-type="item.type"
                  :child-type="item.slideType"
                  :left-side="false"
                  :active="isBoxTypeActive(item)"
                  style="display: flex;"
                />
                <div
                  class="loading-show horizontal layout center center-justified"
                  v-if="item.isLoading"
                >
                  <aha-spinner />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <VideoTutorial v-if="isShowVideoTutorial" />
      <ContentTab />

      <div
        class="tab-content-presentation"
        v-if="slideActive.activeTab == 3"
      >
        <BackgroundConfigV2 />
      </div>

      <div
        class="tab-content-presentation"
        v-if="slideActive.activeTab == 4 && showingAudioTab"
      >
        <AudioConfig />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import Constant from '@/constant'
import Config from '@/config'
import Util from '@/util'
import gaCategories from '@/constant/gaCategories'

import BackgroundConfigV2 from '@/components/presentations/types/BackgroundConfig.v2.vue'
import AudioConfig from '@/components/presentations/types/AudioConfig.vue'
import TakeOverToolbar from '@/components-v2/presentation-editor/TakeOverToolbar.vue'
import FeatureUpdateTooltipContent from '@/components-v2/common/tooltip-feature-update/FeatureUpdateTooltipContent.vue'
import ActiveTab from '@/components-v2/presentation-editor/side-right/ActiveTab.vue'
import ContentTab from '@/components-v2/presentation-editor/side-right/ContentTab.vue'
import SyncLoadingAndMobileTurnOffTabContent from '@/components-v2/presentation-editor/side-right/SyncLoadingAndMobileTurnOffTabContent.vue'
import SelectSlideTypeMixin from '@/mixins/slide/SelectSlideTypeMixin'

import EventBus from '@/eventBus'

import SlideTypeIcon from '@/components-v2/common/slide-type-icon/SlideTypeIcon.vue'

import imageSubmissionTooltipImage from
  '@/assets/images/feature-update/image-submission-feature-update.svg'
import pollTooltipVideo from '@/assets/images/feature-update/poll.webm'
import UndoRedoMixin from '@/mixins/undo-redo/UndoRedoMixin'
import VideoTutorial from '@/components-v2/presentation-editor/side-right/VideoTutorial.vue'

const noAudioTypes = new Set([
  'qrcode',
  'youtube',
  'googleSlides',
  'spinnerWheel',
])
const keyCountOpenEndedUpdateSlide = 'slide-type-open-ended-feature-update'
const keyCountPollUpdate = 'slide-type-poll-update'
const MAX_TIMES_HOVER_BADGE = 10
const RIGHT_SIDE = 'right-side'

export default {
  components: {
    BackgroundConfigV2,
    AudioConfig,
    SlideTypeIcon,
    TakeOverToolbar,
    FeatureUpdateTooltipContent,
    ActiveTab,
    ContentTab,
    SyncLoadingAndMobileTurnOffTabContent,
    VideoTutorial,
  },
  mixins: [UndoRedoMixin, SelectSlideTypeMixin],
  data() {
    return {
      activeTab: 1,
      allTypeSections: [],
      envProduction: false,
      defaultScale: {
        highLabel: this.$t('Strongly agree'),
        lowLabel: this.$t('Strongly disagree'),
        highValue: 5,
        lowValue: 1,
        0: '',
        1: '',
        2: '',
        3: '',
        4: '',
        5: '',
        6: '',
        7: '',
        8: '',
        9: '',
        showAverage: false,
        mustRate: true,
        showMidValues: false,
      },
      imageSubmissionTooltipImage,
      pollTooltipVideo,
    }
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
      showingSlideGrid: (state) => state.indicators.showingSlideGrid,
      selectedSlideIds: (state) => state.selections.selectedSlideIds,
      isDisableEditPresentation: (state) => state.isDisableEditPresentation,
      currentUser: (state) => state.currentUser,
      isShowVideoTutorial() {
        const { videoTutorialUrl } = this.slideActive.typeObj || {}

        return !!videoTutorialUrl
      },
      presentation: (state) => state.presentation,
    }),

    showingAudioTab() {
      return this.$store.getters.selectedSlides.some(
        (s) => s.id && !noAudioTypes.has(s.type),
      )
    },
    isEURegion() {
      return Config.region === Constant.euRegion
    },
    boxLegacyTooltip() {
      return 'This type is no longer available. Try <strong>‘Content’</strong> instead!'
    },
  },
  watch: {
    '$store.state.presentation.language': function () {
      this.defaultScale.highLabel = this.$t('Strongly agree')
      this.defaultScale.lowLabel = this.$t('Strongly disagree')
    },
    selectedSlideIds() {
      setTimeout(() => {
        if (this.selectedSlideIds.length > 1 && this.activeTab < 3) {
          this.activeTabSlide(3)
        } else if (noAudioTypes.has(this.$store.getters.selectedSlide.type)) {
          this.activeTabSlide(2)
        }
      }, 200)
    },
    '$store.state.currentUser.id': function () {
      this.handleShowUpdateBadge()
    },
  },

  created() {
    const allTypeSections = [...Constant.allTypeSections]
    this.allTypeSections = this.allTypeSections.concat(allTypeSections)
    if (Config.domain === 'ahaslides.com') {
      this.envProduction = true
    }

    this.preloadImageSubmissionFeatureImage()
    this.handleShowUpdateBadge()
  },

  methods: {
    isBoxTypeActive(item) {
      const { type, slideType } = this.slideActive
      return (type === item.type && slideType === item.slideType) ||
        (type === 'multipleChoice' && item.type === 'imageChoice')
    },
    featureTooltipTitle(slideType) {
      if (slideType === 'multipleChoice' || slideType === 'imageChoice') {
        return '<div class="font-bold">👉<span class="pl-1.5">Feature update:</span></div>'
      }
      if (slideType === 'openEnded' && !this.isEURegion) {
        return `
          <div class="font-bold">👉 A new way to answer:</div>
        `
      }
      return ''
    },
    featureTooltipContent(slideType) {
      if ((slideType === 'multipleChoice' || slideType === 'imageChoice')) {
        return `
          <div class="w-40">
            <p class="pb-1">The slide types ‘Multiple Choice’ and ‘Image Choice’ have been merged into <strong>‘Poll’</strong>. Your content is unchanged.</p>
            <video width="174" height="92" id="poll-video" autoplay>
              <source src='${pollTooltipVideo}' type="video/webm">
              Your browser does not support the video tag.
            </video>
          </div>
        `
      }
      if (slideType === 'openEnded' && !this.isEURegion) {
        return `
         <div class="w-40">
            <p class="pb-1">Participants can now respond with photos.</p>
            <img src='${imageSubmissionTooltipImage}' width="174" height="92" />
          </div>
        `
      }
      return ''
    },
    isFeatureUpdateTooltipVisible(slide) {
      if (slide.isUpdated) {
        if (slide.type === 'openEnded' && this.isEURegion) {
          return false
        }
        return true
      }
      return false
    },

    _getKeyUpdateBadge(slideType, isNewKey = false) {
      let key
      const poll = ['multipleChoice', 'imageChoice']

      if ((poll.includes(slideType))) {
        key = keyCountPollUpdate
      }
      if (slideType === 'openEnded' && !this.euRegion) {
        key = keyCountOpenEndedUpdateSlide
      }
      if (isNewKey) {
        key = `${this.currentUser.id}-${key}`
      }
      return key
    },

    _removeAndSetNewKeyUpdateBadge(key) {
      // Old rule: https://ahaslides.atlassian.net/browse/AHA-6520
      // New rule: https://ahaslides.atlassian.net/browse/AHA-7126
      const keyValue = window.localStorage.getItem(key)
      if (keyValue) {
        // Old rule: MAX_TIMES_HOVER_BADGE = 3
        if (keyValue > 2) {
          window.localStorage.setItem(
            `${this.currentUser.id}-${key}`,
            MAX_TIMES_HOVER_BADGE,
          )
        } else {
          window.localStorage.setItem(`${this.currentUser.id}-${key}`, keyValue)
        }
        // If 2 userIds use same browser, 2nd userId won't show badge if (key) => remove old key
        window.localStorage.removeItem(key)
      }
    },

    async handleShowUpdateBadge() {
      try {
        this.allTypeSections.forEach((item) => {
          item.slideTypes.forEach((slide) => {
            if (!slide.isUpdated) return
            const key = this._getKeyUpdateBadge(slide.type)
            this._removeAndSetNewKeyUpdateBadge(key)
            this._setUpdateBadge(
              slide,
              this._getKeyUpdateBadge(slide.type, true),
            )
          })
        })
      } catch {
        // do nothing
      }
    },

    _setUpdateBadge(slide, key) {
      let count
      if (slide.isUpdated) {
        count = window.localStorage.getItem(key) || 0
        if (count == MAX_TIMES_HOVER_BADGE) {
          slide.isUpdated = false
          return
        }
        if (this.currentUser.id) {
          const timeDeployUpdate = 1647837000000 // 21/03/2022 11:30
          const timeUserCreatedAt = new Date(
            this.currentUser.createdAt,
          ).getTime()
          if (timeDeployUpdate < timeUserCreatedAt) {
            slide.isUpdated = false
          }
        }
      }
    },

    preloadImageSubmissionFeatureImage() {
      Util.preloadImage({ url: imageSubmissionTooltipImage })
    },

    handleHoverOnSlideType(item, mode) {
      if (this.$store.state.isTouchScreen) return
      EventBus.$emit('handleHoverOnSlideType', item, mode, RIGHT_SIDE)
      if (item.isUpdated && (item.type === 'multipleChoice' || item.type === 'imageChoice')) {
        this._setPlayPollVideo(mode)
      }
      if (item.isUpdated && mode === 'over') {
        const key = this._getKeyUpdateBadge(item.type, true)
        this._setCountHoverUpdateBadgeToLocalStorage(key)
      }
    },

    _setPlayPollVideo(mode) {
      const vid = document.getElementById('poll-video')
      if (!vid) return
      if (mode === 'over') {
        vid.currentTime = 0
        vid.play().catch(() => {})
      } else {
        vid.pause()
      }
    },

    _setCountHoverUpdateBadgeToLocalStorage(key) {
      let count = window.localStorage.getItem(key) || 0
      count++
      if (count <= MAX_TIMES_HOVER_BADGE) {
        window.localStorage.setItem(key, count)
      }
    },

    activeTabSlide(index) {
      this.$store.dispatch('updateSlideActive', {
        activeTab: index,
      })
      Util.gaTrackEvent(gaCategories.PRESENTATION_EDITOR, 'Right column > Switch tab', null, null, {
        slideId: this.slideActive.id,
        tabIndex: index,
      })
    },

    restoreSelectSlideType(payload) {
      this.selectSlideType(payload, false)
    },

    handleSelectSlideType(obj) {
      this.selectSlideType(obj)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variable.scss';
@import '@/assets/scss-v2/variables.scss';

.right-presentation {
  width: $rightSideWidth;
  background-color: #fff;
  border-left: 1px solid #ebebeb;
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
  -webkit-overflow-scrolling: touch;
  .content-right-presentation {
    position: relative;
    padding: 8px 10px 50px 16px;
    @media (max-width: 500px) {
      padding-right: 10px;
      padding-left: 10px;
    }
  }
}

.content-off-btn {
  background-color: #4cbfb7;
  border-color: #4cbfb7;
  color: #fff;
  &:hover,
  &:not(:disabled):not(.disabled):active,
  &:focus {
    background-color: #3d9c96 !important;
    border-color: #3d9c96 !important;
  }
}
.content-off-btn {
  :not(:disabled):not(.disabled):active {
    box-shadow: inset 0 3px 5px rgba(71, 154, 149, 0.22);
    -webkit-box-shadow: inset 0 3px 5px rgba(71, 154, 149, 0.22);
  }
  &:focus {
    box-shadow: 0 4px 6px rgba(72, 156, 150, 0.11),
      0 1px 3px rgba(72, 156, 150, 0.08), 0 0 0 0.2rem rgba(72, 156, 150, 0.5);
    -webkit-box-shadow: 0 4px 6px rgba(72, 156, 150, 0.11),
      0 1px 3px rgba(72, 156, 150, 0.08), 0 0 0 0.2rem rgba(72, 156, 150, 0.5);
  }
}

.tab-content-presentation {
  padding: 0;
  position: relative;
  z-index: 7; // https://ahaslides.atlassian.net/browse/AHA-14039
  margin-top: 12px;

  .fas,
  .far,
  .fab {
    color: $dark-icon-color;
  }
  .title-table-presentation {
    @apply text-sm font-bold;
    padding-bottom: 10px;
    .title-table-presentation-tooltip {
      font-size: 14px;
      color: #b7b7b7;
    }
  }

  .box-content {
    @apply ring-1 ring-inset ring-secondary-40;
    display: flex;
    border-radius: 4px;
    position: relative;
    overflow: hidden;
    padding: 2px 0 0;
    min-height: 72px;
    transition: 0.5s;
    transition-timing-function: cubic-bezier(0.33, 1, 0.68, 1);
    &:hover {
      @apply shadow-lg;
    }
  }

  .slide-types-wrapper {
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-start;
  }
  .box-type {
    @apply text-secondary-50;
    // width: 104px;
    flex: 0 0 32%;
    margin: 1% 0;
    float: left;
    text-align: center;
    position: relative;
    &:nth-of-type(3n-1) {
    margin-left: 2%;
    margin-right: 2%;
  }

  &.is-eu.updated {
    .box-content:after {
      display: none;
    }
  }

  &.beta,
  &.new, &.legacy,
  &.popular,
  &.comingsoon,
  &.updated {
    .box-content {
      &:after {
        display: block;
        background: #FFB12E;
        position: absolute;
        top: 2px;
        padding-left: 20px;
        right: -21px;
        width: 90px;
        height: 16px;
        line-height: 18px;
        text-align: center;
        font-size: 8px;
        font-weight: bold;
        color: #fff;
        -webkit-transform: rotate(45deg);
        transform: rotate(45deg);
        content: 'Beta';
        text-transform: uppercase;
      }
    }
  }

  &.new {
    .box-content {
      &:after {
        @apply bg-primary-90;
        content: 'New';
        font-size: 9px;
        line-height: 16px;
        box-shadow: -1.33274px 2.66548px 5.33096px rgba(52, 142, 246, 0.31);
      }
    }
  }

  &.legacy {
    .box-content {
      &:after {
        @apply bg-secondary-50;
        content: 'Legacy';
        font-size: 9px;
        line-height: 16px;
        box-shadow: -1.33274px 2.66548px 5.33096px rgba(180, 188, 207, 0.24);
      }
    }
    &::v-deep .aha-slide-type-icon {
      opacity: 0.5;
    }
  }

  &.popular {
    .box-content {
      &:after {
        background-color: #ffa826;
        content: 'Popular';
        box-shadow: -1px 2px 4px rgba(255, 177, 46, 0.4);
      }
    }
  }

  &.comingsoon {
    .box-content {
      &:after {
        background-color: #eb68a0;
        content: 'Coming';
        box-shadow: -1px 2px 4px rgba(235, 104, 160, 0.24);
      }
    }
  }

  &.updated {
    .box-content {
      &:after {
        @apply bg-green-50;
        content: 'Updated';
        font-size: 7.5px;
        line-height: 16px;
        box-shadow: -1.33274px 2.66548px 5.33096px rgba(51, 193, 115, 0.15);
      }
    }
  }

  .loading-show {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #f3f3f3ba;
  }

  &.active {
    .box-content {
      @apply ring-2 ring-primary-90;
    }
  }
}
}

.overlay-disable-edit {
  @apply bg-base-0 opacity-50 absolute left-0 w-full h-full;
  top: 44px;
  z-index: 9;
}

@media only screen and (max-width: 990px) {
  .right-presentation {
    width: 70%;
  }
}

@media only screen and (max-width: 767px) {
  .right-presentation {
    width: 100%;
    display: none;

    &.mobile-active {
      display: block;
    }
  }

  .mobile-active {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    background-color: #fff;
    z-index: 100;
    padding-top: 0;
    &::v-deep {
      .sync-error {
        top: 31px;
        left: -80%;
        .arrow-box::before {
          top: -11px;
          left: 62%;
        }
        .arrow-box::after {
          top: -10px;
          left: 62%;
        }
      }
    }
  }

  .sync-label {
    font-weight: bold;
    color: #888;
    i {
      margin-right: 5px;
      font-size: 20px;
    }
  }
}
@media (max-width: $ipad-breakpoint) {
  .right-presentation {
    width: 100%;
  }
  .right-presentation {
    &.show-grid {
      flex: 1;
    }
  }
}

.take-over--side-right {
  display: none;
}

@media (max-width: $ipad-breakpoint) {
  .take-over--side-right {
    display: flex;
  }
}

@media (max-width: 768px) {
  .take-over--side-right {
    display: none;
  }
}
</style>
